var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMailSentAlready(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.25C15.1028 11.25 12.75 13.6028 12.75 16.5C12.75 19.3972 15.1028 21.75 18 21.75C20.8972 21.75 23.25 19.3972 23.25 16.5C23.25 13.6028 20.8972 11.25 18 11.25ZM18 12.75C20.07 12.75 21.75 14.43 21.75 16.5C21.75 18.57 20.07 20.25 18 20.25C15.93 20.25 14.25 18.57 14.25 16.5C14.25 14.43 15.93 12.75 18 12.75ZM2.25 4.6965L11.5425 11.8448C11.8125 12.0518 12.1875 12.0518 12.4575 11.8448L21.75 4.6965V10.5C21.75 10.914 22.086 11.25 22.5 11.25C22.914 11.25 23.25 10.914 23.25 10.5V4.5C23.25 3.258 22.242 2.25 21 2.25H3C1.758 2.25 0.75 3.258 0.75 4.5V16.5C0.75 17.742 1.758 18.75 3 18.75H11.25C11.664 18.75 12 18.414 12 18C12 17.586 11.664 17.25 11.25 17.25H3C2.586 17.25 2.25 16.914 2.25 16.5V4.6965ZM15.5947 17.0303L17.0947 18.5303C17.3872 18.8235 17.8628 18.8235 18.1553 18.5303L20.4053 16.2803C20.6978 15.9878 20.6978 15.5122 20.4053 15.2197C20.1128 14.9272 19.6372 14.9272 19.3447 15.2197L17.625 16.9395L16.6553 15.9697C16.3628 15.6772 15.8872 15.6772 15.5947 15.9697C15.3022 16.2622 15.3022 16.7378 15.5947 17.0303ZM20.52 3.75H3.48L12 10.3035L20.52 3.75Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailSentAlready);
export default __webpack_public_path__ + "static/media/ic-mail-sent-already.42e574cccacfafa7fbadccefe49ff218.svg";
export { ForwardRef as ReactComponent };